module.exports = __webpack_public_path__ + "img/108.92bcb72d.jpg";